import { render, staticRenderFns } from "./SoupList.vue?vue&type=template&id=f2db2f1e&scoped=true"
import script from "./SoupList.vue?vue&type=script&lang=js"
export * from "./SoupList.vue?vue&type=script&lang=js"
import style0 from "./SoupList.vue?vue&type=style&index=0&id=f2db2f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2db2f1e",
  null
  
)

export default component.exports